import './index.css';
import PartyGame from './components/PartyGame';
import React from 'react';

function Party() {
  return <PartyGame />;
}

export default Party;
